/*
 * @Author:
 * @Date:
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2023-08-24 15:58:13
 */

import * as types from "../constants/ActionTypes";
import * as tools from "../lib/Tools";
import * as expr from "../lib/ToolsExpr";
import * as action from "../lib/BLL";
import { ResolveStatusBug, check_campaign_code, SetKeyToBase64 } from "../lib/Tools";
import { dateSortUtil } from "../Utils/dateSortUtils";
import { navigationSort } from "../Utils/navigationHoverSort";
import { SetSingleCookieV2, GetSingleCookieV2 } from "../Utils";
import Sensor from "../Utils/Sensor";
import GoogleAnalytics from "../Utils/GoogleAnalytics";

function sensorEvent(href, content, omniture, type, type_detail, area) {
  //神策 -- 搜索运营位
  Sensor.go("clickBanner_web", {
    $lib_detail: "PC_Search##sensorEvent##action/index.js##14",
    banner_type: "search",
    banner_content: content,
    banner_belong_area: area || "searchview",
    banner_to_url: href,
    banner_to_page_type: href,
    banner_ranking: "",
    belong_team: "Search",
    campaign_code: omniture || "",
    key_word_tpye: type,
    key_word_tpye_details: type_detail,
  });

  GoogleAnalytics.add({
    event: "search",
    recommendContent: "",
    searchCategory: "自然搜索",
    searchTerm: content,
    cat55: "自然搜索",
    kw55: content
  });
}

export const socialLogin = (params, callback) => {
  return (dispatch, getState) => {
    GoogleAnalytics.add({
      event: "accountLogin",
    });

    action.socialLogin(params, (json) => {
      callback(json);
    });
  };
};

export const getUserCardInfo = (callback) => {
  return (dispatch, getState) => {
    action.getUserCardInfo((json) => {
      ResolveStatusBug(json.status, `index`, `getUserCardInfo`);
      if (json.status === 0) {
        callback(json);
      }
    });
  };
};
export const setAlphabet = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: types.HOME.NAVIGATION_ALPHABET,
      NAVIGATION_ALPHABET: value,
    });
  };
};

export const getTopMenu = () => {
  return (dispatch, getState) => {
    action.getAdvertisingText(
      {
        locationLabel: "PC:HOMEPAGE:TOP_TEXT",
      },
      (json) => {
        ResolveStatusBug(json.status, `index`, `getTopMenu`);
        if (json && json.results && json.status == 0) {
          dispatch({
            type: types.HOME.TOP_MENU,
            TOP_MENU: json.results,
          });
        }
      },
    );
  };
};

export const getFixedRightTop = () => {
  return (dispatch, getState) => {
    action.getAdvertisingText(
      {
        locationLabel: "PC:HOMEPAGE:SIDEBARTOP",
      },
      (json) => {
        ResolveStatusBug(json.status, `index`, `getFixedRightTop`);
        if (json && json.results && json.status == 0) {
          dispatch({
            type: types.HOME.FIXED_RIGHT_TOP,
            FIXED_RIGHT_TOP: json.results,
          });
        }
      },
    );
  };
};

export const getFixedRightBottom = () => {
  return (dispatch, getState) => {
    action.getAdvertisingText(
      {
        locationLabel: "PC:HOMEPAGE:SIDEBARBOTTOM",
      },
      (json) => {
        ResolveStatusBug(json.status, `index`, `getFixedRightBottom`);
        if (json && json.results && json.status == 0) {
          dispatch({
            type: types.HOME.FIXED_RIGHT_BOTTOM,
            FIXED_RIGHT_BOTTOM: json.results,
          });
        }
      },
    );
  };
};

export const setSubCategoryHover = (value, nickname) => {
  return (dispatch, getState) => {
    dispatch({
      type: types.HOME.CATEGORY_HOVER,
      CATEGORY_HOVER: value,
      CATEGORY_NICKNAME: nickname,
    });
  };
};

export const getSubCategory = (prototypeList, value) => {
  return (dispatch, getState) => {
    let categoryItem = expr.exprInt(value * 1);

    // 本地缓存
    let HAS = 0;
    for (let i in prototypeList) {
      if (prototypeList[i].ID === value) {
        HAS = 1;
      }
    }

    if (HAS === 1) {
      return;
    }

    if (categoryItem) {
      action.getSubCategory(value, (json) => {
        if (json) {
          let rule = navigationSort(json);
          dispatch({
            type: types.HOME.CATEGORY,
            CATEGORY_ID: value,
            CATEGORY_RESPONSE: json,
            CATEGORY_RESPONSE_RULE: rule,
          });
        }
      });
    } else {
      action.getAdPositionCategory(value, (json) => {
        if (json) {
          let rule = navigationSort(json);
          dispatch({
            type: types.HOME.CATEGORY,
            CATEGORY_ID: value,
            CATEGORY_RESPONSE: json,
            CATEGORY_RESPONSE_RULE: rule,
          });
        }
      });
    }
  };
};

export const setNickName = (dispatch, getState, cookieName) => {
  let _getSingleCookie = tools.GetSingleCookie(cookieName);
  let _getNickName = null;
  if (_getSingleCookie) {
    _getNickName = tools.GetNickName(_getSingleCookie); // 获取昵称
    dispatch({ type: types.USER.NICK_NAME, NICK_NAME: _getNickName });
  }
};

export const loginOff = () => {
  // return (dispatch, getState) => {
  // tools.soaLoginOff();
  tools.loginOut();
  //tools.loginOff(() => {
  //    setNickName( dispatch, getState, 'UID')
  //})
  // };
};

export const getSingleCookie = () => {
  return (dispatch, getState) => {
    setNickName(dispatch, getState, "user_name");
  };
};

export const getUserInformation = () => {
  return (dispatch, getState) => {
    let userId = tools.GetSingleCookie("user_id") || "6105297";
    if (userId) {
      let params = {
        storeId: "0001",
        userId: userId,
      };
      // has SOA_LOGIN_USER_ID
      action.getUserInformation(params, (json) => {
        ResolveStatusBug(json.status, `index`, `getUserInformation`);
        if (json.status === 0 && json.results) {
          dispatch({
            type: types.USER.USER_ID,
            USER_TYPE: json.results.cardType || null,
            USER_POINT: json.results.points || null,
          });
        }
      });
    }
  };
};

export const getMiniCart = (callback) => {
  return (dispatch, getState) => {
    action.getMiniCart((json) => {
      if (json.status === 0) {
        callback && callback(json.results);
        dispatch({ type: types.USER.MINI_CART, MINI_CART: json.results });
      }
      if (json.errorCode === "CMN1039E") {
        dispatch({ type: types.USER.ERROR_CODE, ERROR_CODE: json.errorCode });
      }
      if (json.errorCode === "2510") {
        dispatch({ type: types.USER.ERROR_CODE, ERROR_CODE: json.errorCode });
      }
    });
  };
};

export const getMiniCartNum = (callback) => {
  return (dispatch, getState) => {
    action.getMiniCartNum((json) => {
      callback && callback(json.results);
      dispatch({
        type: types.USER.MINI_CART_NUM,
        MINI_CART_NUM: json.results,
      });
    });
  };
};

/*export const getUI = () => {
    return (dispatch, getState) => {
        dispatch({
            type: types.UI,
            UI
        });
    };
};*/

export const setSearchTrim = (value) => {
  return (dispatch, getState) => {
    dispatch({ type: types.HOME.SEARCH_TRIM, SEARCH_TRIM: value });
  };
};

export const getCarouselText = () => {
  return (dispatch, getState) => {
    action.getAdvertisingText(
      {
        locationLabel: "PC:HOMEPAGE:TOP_TEXT_CAROUSEL",
      },
      (json) => {
        ResolveStatusBug(json.status, `index`, `getCarouselText`);
        if (json && json.results && json.status == 0) {
          let { resourceList } = json.results;
          dispatch({
            type: types.HOME.TOP_CAROUSEL,
            TOP_CAROUSEL: resourceList,
          });
        }
      },
    );
  };
};

export const setScrollTop = (nodes, value, nickname) => {
  return (dispatch, getState) => {
    dispatch({
      type: types.HOME.CATEGORY_SCROLL_TOP,
      NODES_NAME: nodes,
      SCROLL_TOP: value,
      CONTENT: nickname,
    });
  };
};

export const getSearchPlaceHolder = (callback) => {
  return (dispatch, getState) => {
    action.getAdvertisingText(
      {
        locationLabel: "PC:HOMEPAGE:SEARCHBOX_TEXT",
      },
      (json) => {
        dispatch({
          type: types.ASYNC.GET_SEARCH_PLACEHOLDER,
          GET_SEARCH_PLACEHOLDER: json,
        });
        callback && callback(json);
      },
    );
  };
};

export const getSearchHotWorld = () => {
  // PC:HOMEPAGE:POPULAR_TEXT
  return (dispatch, getState) => {
    action.getAdvertisingTextNew(
      {
        locationLabel: "PC:HOMEPAGE:POPULAR_TEXT",
      },
      (json) => {
        dispatch({
          type: types.ASYNC.GET_SEARCH_HOT_WORLD,
          GET_SEARCH_HOT_WORLD: json,
        });
      },
    );
  };
};

export const getNavigationGroup = () => {
  return (dispatch, getState) => {
    action.getNavigationGroup((json) => {
      dispatch({
        type: types.ASYNC.GET_NAVIGATION_GROUP,
        GET_NAVIGATION_GROUP: json,
      });
    });
  };
};

export const getNavigationBrandGroup = () => {
  return (dispatch, getState) => {
    action.getNavigationBrandGroup((json) => {
      dispatch({
        type: types.ASYNC.GET_NAVIGATION_BRAND_GROUP,
        GET_NAVIGATION_BRAND_GROUP: json,
      });
    });
  };
};

export const getCategoryFixed = () => {
  return (dispatch, getState) => {
    action.getAdvertisingText(
      {
        locationLabel: "PC:HOMEPAGE:GUIDEFLOAT",
      },
      (json) => {
        ResolveStatusBug(json.status, `index`, `getCategoryFixed`);
        if (json.status === 0 && json.results && json.results.resourceList) {
          dispatch({
            type: types.HOME.FIXED_LEFT_CATEGORY,
            FIXED_LEFT_CATEGORY: json.results.resourceList,
          });
        }
      },
    );
  };
};

export const postLive800Msg = (params, callback) => {
  return (dispatch, getState) => {
    action.postLive800Msg(params, (json) => {
      ResolveStatusBug(json.status, `index`, `postLive800Msg`);
      if (json.status === 0 && json.results) {
        callback(json.results);
      }
    });
  };
};

/* 首页新增预约活动中心 */
export const postIndexReservation = (params, callback) => {
  return (dispatch, getState) => {
    action.postIndexReservation(params, (json) => {
      ResolveStatusBug(json.status, `index`, `postIndexReservation`);
      if (json.status === 0 && json.results) {
        callback(json.results);
      }
    });
  };
};

/*
 * 搜索框逻辑优化修改
 */
export const dealWithData = (dispatch, getState, dir, TYPE) => {
  // 处理搜索框placeholder广告位
  let { searchPlaceHolder, async, keywordData, hotWordsData, home } = getState(),
    placeholders = [],
    placeholder = "",
    value = dir.refs.searchInput.value;
  // 1.页面异步请求获取广告位 : 超过4个截取前4个
  if (
    !searchPlaceHolder.results &&
    async.searchPlaceHolder &&
    async.searchPlaceHolder.results &&
    async.searchPlaceHolder.results.resourceList.length
  ) {
    placeholders = async.searchPlaceHolder.results.resourceList.slice(0, 4);
  }
  // 2.页面同步获取广告位 : 超过4个截取前4个
  if (
    searchPlaceHolder &&
    searchPlaceHolder.results &&
    searchPlaceHolder.results.resourceList.length
  ) {
    placeholders = searchPlaceHolder.results.resourceList.slice(0, 4);
  }
  // 3.热搜词页面 && 搜索此页面逻辑  ==> 相当于有一个广告位的情况，并且link链接到search页面
  if ((keywordData && keywordData.results) || (hotWordsData && hotWordsData.results)) {
    let text =
      (keywordData && keywordData.results && keywordData.results.keyWords) ||
      (hotWordsData && hotWordsData.results && hotWordsData.results.hotWords);
    placeholders = [{ content: text, link: `/search/?k=${SetKeyToBase64(text)}`, isSearch: true }];
  }
  if (placeholders.length == 0) {
    placeholder = "请输入您要搜索的关键词";
  }
  if (placeholders.length == 1) {
    placeholder = placeholders[0];
  }
  if (placeholders.length > 1) {
    !value && openTimer(placeholders, TYPE)(dispatch, getState);
  }
  return {
    placeholders: placeholders,
    placeholder: placeholder,
    value: value,
  };
};

export const clearMyTimer = (TYPE) => (dispatch, getState) => {
  let { home } = getState(),
    { SearchInnerFixed, SearchInnerStatic } = home,
    myTimerType = getType(TYPE, "MYTIMER"),
    myTimer;
  TYPE == "static" && (myTimer = SearchInnerStatic.myTimer);
  TYPE == "fixed" && (myTimer = SearchInnerFixed.myTimer);
  myTimer && clearInterval && clearInterval(myTimer);
  if (myTimerType) {
    dispatch({ type: myTimerType, myTimer: null });
  }
};

// 按照type类型拆分状态
export const getType = (TYPE, constant) => {
  let _type;
  if (TYPE == "static") {
    constant == "MYTIMER" && (_type = types.HOME.SEARCH_MYTIMER_STATIC);
    constant == "PLACEHOLDER" && (_type = types.HOME.SEARCH_INNER_PLACEHOLDER_STATIC);
    constant == "PLACEHOLDERS" && (_type = types.HOME.SEARCH_INNER_PLACEHOLDERS_STATIC);
    constant == "UPDOWN" && (_type = types.HOME.PRESS_UP_DOWN_STATIC);
  }
  if (TYPE == "fixed") {
    constant == "MYTIMER" && (_type = types.HOME.SEARCH_MYTIMER_FIXED);
    constant == "PLACEHOLDER" && (_type = types.HOME.SEARCH_INNER_PLACEHOLDER_FIXED);
    constant == "PLACEHOLDERS" && (_type = types.HOME.SEARCH_INNER_PLACEHOLDERS_FIXED);
    constant == "UPDOWN" && (_type = types.HOME.PRESS_UP_DOWN_FIXED);
  }
  return _type;
};

// 默认搜索展开层逻辑
export const getDefaultModule = (TYPE) => (dispatch, getState) => {
  let productIds = [],
    keywordsHistory = [],
    type = TYPE == "static" ? types.HOME.SEARCH_RESULTS_STATIC : types.HOME.SEARCH_RESULTS_FIXED;
  if (GetSingleCookieV2({ key: "productIds" }))
    productIds = GetSingleCookieV2({ key: "productIds" }).split(",");
  if (GetSingleCookieV2({ key: "keywordsHistoryV2" }))
    keywordsHistory = GetSingleCookieV2({ key: "keywordsHistoryV2" }).split(",");
  dispatch({ type: types.HOME.SEARCHHISTORY, SearchHistory: keywordsHistory });
  // 默认产品获取: 不管有没有都去请求
  action.getProductsByIds(productIds, (json) => {
    if (json && json.status === 0) {
      dispatch({
        type: types.HOME.DEFAULTPRODUCTS,
        DefaultProducts: json.results,
      });
      dispatch({
        type: type,
        down: 0,
        results: null,
        suggestList: null,
        suggestProductList: null,
        DefaultModule: 1,
      });
    }
  });
  return;
};

export const matchBrand = (brandGroup, value) => {
  if (!(brandGroup instanceof Array)) return false;
  for (let i in brandGroup) {
    for (let j in brandGroup[i].brandList) {
      let brandNameEN = brandGroup[i] &&
              brandGroup[i].brandList &&
              brandGroup[i].brandList[j].brandNameEN &&
              brandGroup[i].brandList[j].brandNameEN.toLowerCase();
      let valueLowerCase = value && value.toLowerCase();
      let brandNickNames = brandGroup[i] &&
                 brandGroup[i].brandList &&
          brandGroup[i].brandList[j].brandNickNames &&
          brandGroup[i].brandList[j].brandNickNames.map((item) =>
          item && item.toLowerCase(),
      );
      if (
        brandNameEN == valueLowerCase ||
        brandGroup[i].brandList[j].brandNameCN == value ||
          (brandNickNames && brandNickNames.includes(valueLowerCase))
      ) {
        return `/brand/${brandNameEN.replace(/\s/g, "")}-${brandGroup[i].brandList[j].brandId}/`;
      }
    }
  }
  return false;
};

// 关键词存入 cookie
export const setKeywords = ({ key = null, value = null, length = 10 }) => {
  if (!value || !key) return;
  // 1.关键词已经搜索过但是被清空了: ""
  // 2.关键词为第一次搜索: false
  let keywordsHistory = [];
  let time = 3 * 365 * 24 * 60 * 60 * 1000;
  if (GetSingleCookieV2({ key: key })) keywordsHistory = GetSingleCookieV2({ key: key }).split(",");
  // 3.关键词非第一次搜索
  let keywordIndex = keywordsHistory.findIndex((item, index, arr) => item == value);
  if (keywordIndex != -1) keywordsHistory.splice(keywordIndex, 1);

  keywordsHistory.unshift(value);
  // 4.关键词最多保留 n 个
  let keywords = [...keywordsHistory];
  if (keywordsHistory.length > length) keywords = keywordsHistory.slice(0, length);

  SetSingleCookieV2({
    key: key,
    value: keywords.join(","),
    time: time,
    path: "/",
  });
};
// 联想词逻辑跳转
export const getAssociativeHref = (TYPE) => (dispatch, getState) => {
  let { home } = getState(),
    { SearchResultsStatic, SearchResultsFixed, UpDownKeyCodeStatic, UpDownKeyCodeFixed } = home,
    suggestList =
      TYPE == "static"
        ? SearchResultsStatic && SearchResultsStatic.suggestList
        : SearchResultsFixed && SearchResultsFixed.suggestList,
    order = TYPE == "static" ? UpDownKeyCodeStatic : UpDownKeyCodeFixed,
    associativeHref = "";
  if (order != null && suggestList && suggestList.length > 0 && suggestList[order]) {
    if (suggestList[order].suggestKeyWord)
      associativeHref = `/search/?k=${SetKeyToBase64(suggestList[order].suggestKeyWord)}`;
    if (suggestList[order].suggestBrandEn)
      associativeHref = `/brand/${suggestList[order].suggestBrandEn.replace(/\s/g, "")}-${suggestList[order].suggestBrandId
        }/`;
    suggestList[order].suggestKeyWord &&
      setKeywords({
        key: "keywordsHistoryV2",
        value: suggestList[order].suggestKeyWord,
        length: 10,
      });
    return associativeHref;
  }
  return false;
};

/**
 * @Function 完成握手,A/B站跳转
 * @param {String} value 输入词 || 历史搜索词
 * @param {Number|Boolean} isHistory 是否是历史搜索词
 *
 */
export const getSearchHref = (value) => {
  location.href = `/search/?k=${SetKeyToBase64(value)}`;
};
// 搜索跳转
export const skip = (e, dir, TYPE) => (dispatch, getState) => {
  let { home, navigationBrandGroup, async } = getState(),
    { SearchInnerStatic, SearchInnerFixed } = home,
    associativeHref = getAssociativeHref(TYPE)(dispatch, getState),
    placeholder = "";
  if (associativeHref) {
    location.href = associativeHref;
    return;
  }
  if (TYPE == "static") placeholder = SearchInnerStatic.placeholder;
  if (TYPE == "fixed") placeholder = SearchInnerFixed.placeholder;

  let value = dir.refs.searchInput.value,
    brandGroup =
      (navigationBrandGroup && navigationBrandGroup.results) ||
      (async.navigationBrandGroup && async.navigationBrandGroup.results);
  value = value.replace(/\%|\#/g, "").trim();

  if (!value) {
    // 为空
    GoogleAnalytics.add({
      event: "search",
      searchCategory: "点击搜索",
      searchTerm: value,
      cat55: "点击搜索",
      kw55: value
    });
    if (placeholder && placeholder.content && placeholder.link) {
      let href =
        placeholder.link && check_campaign_code(placeholder.link)
          ? placeholder.link
          : placeholder.omniture
            ? placeholder.link + placeholder.omniture
            : placeholder.link;
      sensorEvent(
        placeholder.link,
        placeholder.content,
        placeholder.omniture,
        "ClickTerm",
        "Default",
      );
      location.href = href; // --- zone 埋点修改
      return;
    }
    if (placeholder && placeholder.content && !placeholder.link) {
      let href = `/hot/?k=${SetKeyToBase64(placeholder.content)}`;
      sensorEvent(href, placeholder.content, placeholder.omniture, "ClickTerm", "Default");
      location.href = placeholder.omniture ? href + placeholder.omniture : href; // --- zone 埋点修改
      return;
    }
  } else {
    let href = !!matchBrand(brandGroup, value)
      ? matchBrand(brandGroup, value)
      : `/search/?k=${SetKeyToBase64(value)}`;
    setKeywords({ key: "keywordsHistoryV2", value: value, length: 10 });
    sensorEvent(href, value, "", "ManualInput", "Organic");
    if (!!matchBrand(brandGroup, value)) {
      location.href = matchBrand(brandGroup, value);
      return;
    }
    getSearchHref(value);
  }
};

export const openTimer = (placeholders, TYPE) => (dispatch, getState) => {
  let order = 0,
    placeholderType = getType(TYPE, "PLACEHOLDER"),
    myTimerType = getType(TYPE, "MYTIMER"),
    myTimer = null;
  setInterval &&
    (myTimer = setInterval(() => {
      dispatch({ type: placeholderType, placeholder: placeholders[order] });
      if (order < placeholders.length - 1) {
        order++;
      } else {
        order = 0;
      }
    }, 3000));
  dispatch({ type: myTimerType, myTimer: myTimer });
};

export const initSearchData = (dir, TYPE) => {
  return (dispatch, getState) => {
    let obj = dealWithData(dispatch, getState, dir, TYPE),
      placeholderType = getType(TYPE, "PLACEHOLDER"),
      placeholdersType = getType(TYPE, "PLACEHOLDERS");
    dispatch({ type: placeholdersType, placeholders: obj.placeholders });
    dispatch({ type: placeholderType, placeholder: obj.placeholder });
  };
};

// 历史搜索词链接跳转 : 点击历史搜索关键词( 注意区分是进“品牌页”还是“结果页” )
export const handleSearchHistory = (item, e) => (dispatch, getState) => {
  e && e.preventDefault();
  GoogleAnalytics.add({
    event: "search",
    searchCategory: "History Search",
    searchTerm: item,
    cat55: "History Search",
    kw55: item
  });
  let { navigationBrandGroup, async } = getState(),
    keywordsHistory = [],
    brandGroup =
      (navigationBrandGroup && navigationBrandGroup.results) ||
      (async.navigationBrandGroup && async.navigationBrandGroup.results);
  let href = !!matchBrand(brandGroup, item)
    ? matchBrand(brandGroup, item)
    : `/search/?k=${SetKeyToBase64(item)}`;
  setKeywords({ key: "keywordsHistoryV2", value: item, length: 10 });
  sensorEvent(href, item, "", "ClickTerm", "History Search");
  if (!!matchBrand(brandGroup, item)) {
    location.href = matchBrand(brandGroup, item);
    return;
  }
  getSearchHref(item);
  // window.location.href = href;
};
// 换一换
export const switchProducts = () => (dispatch, getState) => {
  let { home } = getState(),
    { SwitchProducts, DefaultProducts } = home;
  //console.log('switchProducts---------->',SwitchProducts);
  if (DefaultProducts && DefaultProducts.length > 4) {
    dispatch({
      type: types.HOME.SWITCHPRODUCTS,
      SwitchProducts: !SwitchProducts,
    });
  }
};
// 清空历史搜索
export const removeHistory = () => (dispatch, getState) => {
  let expiresTime = -1 * 24 * 60 * 60 * 1000;
  SetSingleCookieV2({
    key: "keywordsHistoryV2",
    value: "",
    time: expiresTime,
    path: "/",
  });
  SetSingleCookieV2({
    key: "productIds",
    value: "",
    time: expiresTime,
    path: "/",
  });
  dispatch({ type: types.HOME.SEARCHHISTORY, SearchHistory: null });
  dispatch({ type: types.HOME.DEFAULTPRODUCTS, DefaultProducts: null });
};

// 搜索框事件===================================================================
export const handleFocus = (dir, TYPE) => (dispatch, getState) => {
  clearMyTimer(TYPE)(dispatch, getState);
  let placeholderType = getType(TYPE, "PLACEHOLDER"),
    { home } = getState(),
    { SearchInnerStatic } = home,
    { placeholder } = SearchInnerStatic;
  placeholder.isSearch && (dir.refs.searchInput.value = placeholder.content); // 只是针对search页面 和 hot页面
  sensorEvent("", dir.refs.searchInput.value, null, null, null, "searchbar");
  dispatch({ type: placeholderType, placeholder: "" });
};

export const handleBlur = (dir, TYPE) => (dispatch, getState) => {
  let obj = dealWithData(dispatch, getState, dir, TYPE),
    placeholderType = getType(TYPE, "PLACEHOLDER");
  dispatch({
    type: placeholderType,
    placeholder: obj.placeholder,
  });
};

export const handleChange = (e, dir, TYPE) => (dispatch, getState) => {
  clearMyTimer(TYPE)(dispatch, getState);
  let value = dir.refs.searchInput.value,
    type = TYPE == "static" ? types.HOME.SEARCH_RESULTS_STATIC : types.HOME.SEARCH_RESULTS_FIXED;
  if (value.trim() == "") {
    getDefaultModule(TYPE)(dispatch, getState);
    return;
  }
  action.getSearchResultsV2(value, (json) => {
    if (json && json.status === 0) {
      let suggestList = json.results.suggestList && json.results.suggestList.slice(0, 3), // 要求最多显示3条
        suggestBrandDtoList =
          json.results.suggestBrandDtoList && json.results.suggestBrandDtoList.slice(0, 3), // 要求最多显示3条
        suggestProductList =
          json.results.suggestProductList && json.results.suggestProductList.slice(0, 6); // 要求最多显示6条
      suggestList = [...suggestList, ...suggestBrandDtoList];
      let keyCodeType = getType(TYPE, "UPDOWN");
      dispatch({ type: keyCodeType, keyCode: null }); // 选择上下后选中到某个位置，然后又进行输入搜索再次去选择
      dispatch({
        type: type,
        results: json.results,
        down: 1,
        suggestList,
        suggestProductList,
        DefaultModule: 0,
      });
      GoogleAnalytics.add({
        event: "search",
        recommendContent: suggestProductList,
        searchCategory: "自然搜索",
        searchTerm: value,
        cat55: "自然搜索",
        kw55: value
      });
    }
  });
};
export const handleKeyUp = (e, dir, TYPE) => (dispatch, getState) => {
  // (e.keyCode == '13') && skip( e,dir )( dispatch, getState );
  if (e.keyCode == "13") {
    skip(e, dir, TYPE)(dispatch, getState);
    return;
  }

  //输入框清空后偶然出现联想词的问题
  let value = dir.refs.searchInput.value;
  if (value.trim() == "") {
    getDefaultModule(TYPE)(dispatch, getState);
    return;
  }
};

export const handleMouseLeave = (TYPE) => (dispatch, getState) => {
  let type = TYPE == "static" ? types.HOME.SEARCH_RESULTS_STATIC : types.HOME.SEARCH_RESULTS_FIXED;
  let keyCodeType = getType(TYPE, "UPDOWN");
  dispatch({ type: type, down: 0, DefaultModule: 0 });
  dispatch({ type: keyCodeType, keyCode: null });
};

export const handleClick = (e, dir, TYPE) => (dispatch, getState) => {
  console.log(e,'e');
  console.log(dir,'dir');
  console.log(TYPE,'TYPE');
  skip(e, dir, TYPE)(dispatch, getState);
};
export const handleKeyDown = (e, dir, TYPE) => (dispatch, getState) => {
  if (e.keyCode != 38 && e.keyCode != 40) return;
  let keyCodeType = getType(TYPE, "UPDOWN"),
    { home } = getState(),
    { SearchResultsStatic, SearchResultsFixed, UpDownKeyCodeStatic, UpDownKeyCodeFixed } = home,
    suggestList =
      TYPE == "static" ? SearchResultsStatic.suggestList : SearchResultsFixed.suggestList,
    length = suggestList && suggestList.length && suggestList.length - 1,
    order = TYPE == "static" ? UpDownKeyCodeStatic : UpDownKeyCodeFixed;
  // if( !length ) return; // suggestList长度是 0 || suggestList不存在的情况
  if (length < 0 || length == undefined || length == null) return; // suggestList长度是 0 || suggestList不存在的情况
  // 选择上下后选中到某个位置，然后又进行输入搜索再次去选择 --> 在onChange事件中做
  // 上键: 0 || null
  // 下键: null || 等于数据长度的时候
  // 正常加减
  if (e.keyCode == 38) {
    if (order == null || order == 0) {
      order = length;
    } else {
      order = order - 1;
    }
  }
  if (e.keyCode == 40) {
    if (order == null || order == length) {
      order = 0;
    } else {
      order = order + 1;
    }
  }
  dir.refs.searchInput.value =
    suggestList &&
    suggestList[order] &&
    (suggestList[order].suggestBrandEn || suggestList[order].suggestKeyWord);
  dispatch({ type: keyCodeType, keyCode: order });
};


export const setMiniCart = (para, callback) => {
  let ordinaryShopCartSkus = [];
  if (para && para.results && para.results.shopcartSkus) {
    ordinaryShopCartSkus = para.results.shopcartSkus;
  }
  return (dispatch, getState) => {
    dispatch({
      type: types.USER.MINI_CART,
      MINI_CART: {
        invalidShopCartSkus: [],
        ordinaryShopCartSkus,
        presaleShopCartSkus: [],
        totalAmount: para.results.totalAmount,
        totalItems: para.results.normalOrderItems,
      }
    });
  };
};


export const getIsHomeGrey = (callback) => {
  return (dispatch, getState) => {
    action.getIsHomeGrey((json) => {
      if (json.status === 0) {
        callback(json);
      }
    });
  };
};

export const getFirstOrder = () => {
  return (dispatch, getState) => {
    action.getFirstOrder((json) => {
      if (json && json.results && json.status == 0) {
        dispatch({
          type: types.HOME.FIRSTORDERGIFT,
          FirstOrderGift: json.results
        })
      }
    });
  };
}
export const getPcConfig = (callback) => {
  return (dispatch, getState) => {
    action.getPcConfig((json) => {
      if (json && json.results && json.status == 0) {
        callback(json.results);
      }
    });
  };
}


// WEBPACK FOOTER //
// ./common/actions/index.js